module.exports = __webpack_public_path__ + "img/abu.f6f41643.svg";